import { SegmentedControl, ICON_SYSTEM, ICON_LIGHT, ICON_DARK } from "./ui/SegmentedControl";
import { WorkshopHolidayRow } from "./WorkshopHolidayRow";
import type { BootstrapResponse } from "../types";

/* 설정 창의 첫 칸 = 저쪽 설정 창의 General (2026-10-19 지윤 지시).
   거기도 Appearance > Theme 가 맨 위 줄이고, 계정 칸에는 계정 사실만 남는다.
   줄 모양은 계정 칸과 같은 부품을 쓴다(account-settings-row) — 같은 창 안에서 두 칸이
   다른 문법으로 서면 설정이 두 군데서 온 것처럼 읽힌다. */
export function GeneralSettings({ theme, onThemeChange, data, refresh, actorName, canEdit }: {
  theme: "system" | "light" | "dark";
  onThemeChange: (next: "system" | "light" | "dark") => void;
  /* 2026-10-19 지윤 지시: 휴무일도 여기로. 쉬는 날은 한 사람의 설정이 아니라 **공장이 어떻게
     도는가**라, 테마와 같은 "일반" 칸에 선다 — 칸 하나를 따로 둘 만큼 큰 일이 아니다. */
  data?: BootstrapResponse; refresh?: () => Promise<void>; actorName: string; canEdit: boolean;
}) {
  return <div className="account-settings">
    <section className="account-settings-group" aria-label="화면">
      <h3>화면</h3>
      <div className="account-settings-row">
        <div><span>테마</span><p>이 기기에만 저장됩니다.</p></div>
        <SegmentedControl ariaLabel="테마" value={theme} onChange={onThemeChange}
          options={[{ value: "system", label: "시스템", icon: ICON_SYSTEM },
                    { value: "light", label: "라이트", icon: ICON_LIGHT },
                    { value: "dark", label: "다크", icon: ICON_DARK }]} />
      </div>
    </section>
    {canEdit && data && refresh && <section className="account-settings-group" aria-label="작업실 휴무일">
      <h3>작업실 휴무일</h3>
      <WorkshopHolidayRow data={data} refresh={refresh} actorName={actorName} />
    </section>}
  </div>;
}
